export interface RescheduleAvailability {
  isVisible: boolean;
  isEnabled: boolean;
  showsPackageTooltip: boolean;
}

interface Params {
  canReschedule: boolean;
  isRescheduleInProgress: boolean;
  isPackageItem: boolean;
}

export function resolveRescheduleAvailability({
  canReschedule,
  isRescheduleInProgress,
  isPackageItem,
}: Params): RescheduleAvailability {
  return {
    isVisible: canReschedule && !isRescheduleInProgress,
    isEnabled: !isPackageItem,
    showsPackageTooltip: isPackageItem,
  };
}
